const SAFETY_NOTE =
  'この会話は選考評価に使用されません。個人が特定される情報の入力は不要です。';

interface MotifProps {
  className: string;
  color: string;
  shape: string;
}

function Motif({ className, color, shape }: MotifProps) {
  return (
    <span
      aria-hidden="true"
      className={`pointer-events-none absolute ${className}`}
      style={{ background: color, clipPath: shape }}
    />
  );
}

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#F7F4EE] pt-[112px] pb-6 sm:pt-36 sm:pb-14">
      <Motif
        className="left-[-3rem] top-20 h-32 w-32 opacity-70 sm:h-44 sm:w-44"
        color="#FFFFFF"
        shape="polygon(0 0, 100% 100%, 0 100%)"
      />
      <Motif
        className="right-[-4rem] top-16 h-40 w-40 opacity-95 sm:right-[-2rem] sm:h-56 sm:w-56"
        color="#060148"
        shape="polygon(100% 0, 100% 100%, 0 0)"
      />
      <Motif
        className="right-[-2rem] top-[250px] h-14 w-14 opacity-45 sm:right-24 sm:top-60 sm:opacity-80"
        color="#E85B63"
        shape="polygon(50% 0, 0 100%, 100% 100%)"
      />
      <Motif
        className="left-6 bottom-2 h-20 w-20 opacity-50 sm:left-20 sm:h-28 sm:w-28"
        color="#4E73B8"
        shape="polygon(0 100%, 100% 100%, 0 0)"
      />

      <div className="relative z-10 mx-auto w-full max-w-6xl px-5 sm:px-8">
        <div className="max-w-4xl">
          <h1 className="max-w-5xl text-[42px] font-extrabold leading-[1.18] text-[#060148] sm:text-[64px] md:text-[72px] lg:text-[80px]">
            <span className="block sm:hidden">
              SPECIAL
              <br />
              THANKS
              <br />
              <span className="whitespace-nowrap">採用AI相談</span>
            </span>
            <span className="hidden sm:block">SPECIAL THANKS 採用AI相談</span>
          </h1>

          <p className="mt-6 max-w-3xl text-[18px] font-medium leading-[1.85] text-[#222222] sm:mt-9 sm:text-[20px] sm:leading-[1.85]">
            応募前、面接前、内定承諾前。選考中に気になるような少し聞きにくいことも、選考評価を気にせずに、ここで整理できます。
          </p>

          <p className="mt-5 max-w-3xl border-l-2 border-[#E85B63] pl-4 text-[16px] font-semibold leading-[1.75] text-[#E85B63] sm:mt-7 sm:text-[17px]">
            {SAFETY_NOTE}
          </p>
        </div>
      </div>
    </section>
  );
}
